The workflow process history of the candidate.

A maximum of 20 process history items may be provided on initial upload.
